export default __webpack_public_path__ + "e404294387003c3474b50c89bcc8169d.svg";